import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowUp, ArrowDown, PushPin } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import api, { apiErrorMessage } from "@/lib/api";
import { NAV_LABELS } from "@/lib/navConfig";

export function NavBarSettings() {
  const [order, setOrder] = useState([]);
  const [hidden, setHidden] = useState([]);
  const [meta, setMeta] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/navbar").then(({ data }) => { setOrder(data.order); setHidden(data.hidden); setMeta(data); }).catch(() => {}); }, []);
  const move = (i, d) => { const o = [...order]; [o[i], o[i + d]] = [o[i + d], o[i]]; setOrder(o); };
  const toggle = (k) => setHidden(hidden.includes(k) ? hidden.filter((x) => x !== k) : [...hidden, k]);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/navbar", { order, hidden });
      setMeta(data); window.dispatchEvent(new Event("navbar-updated"));
      toast.success("Nav bar saved for all users");
    } catch (e) { toast.error(apiErrorMessage(e, "Save failed")); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-xl space-y-4" data-testid="navbar-settings">
      <div>
        <div className="text-base font-bold text-slate-900 flex items-center gap-1.5"><PushPin size={16} className="text-[#327de3]" /> Top nav bar</div>
        <p className="text-xs text-slate-500 mt-1">Pick which pages are pinned to the blue top bar, and their order, for every user. This only changes the top bar. The left hamburger menu always lists every page, and each user still sees only the pages they have access to.</p>
      </div>
      <div className="rounded-xl border border-slate-200 bg-white divide-y divide-slate-100" data-testid="navbar-list">
        {order.map((k, i) => (
          <div key={k} className="flex items-center gap-3 px-3 py-2" data-testid={`navbar-item-${k}`}>
            <Checkbox checked={!hidden.includes(k)} onCheckedChange={() => toggle(k)} data-testid={`navbar-check-${k}`} />
            <span className={`flex-1 text-sm ${hidden.includes(k) ? "text-slate-400" : "text-slate-800 font-semibold"}`}>{NAV_LABELS[k] || k}</span>
            <span className="text-[10px] text-slate-400 w-24 text-right">{hidden.includes(k) ? "menu only" : "pinned"}</span>
            <button disabled={i === 0} onClick={() => move(i, -1)} className="p-1 rounded hover:bg-slate-100 disabled:opacity-30" data-testid={`navbar-up-${k}`}><ArrowUp size={14} /></button>
            <button disabled={i === order.length - 1} onClick={() => move(i, 1)} className="p-1 rounded hover:bg-slate-100 disabled:opacity-30" data-testid={`navbar-down-${k}`}><ArrowDown size={14} /></button>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-3">
        <Button onClick={save} disabled={busy || !order.length} className="bg-[#327de3] text-white hover:bg-[#1f64c2]" data-testid="navbar-save">Save for all users</Button>
        <span className="text-[11px] text-slate-400" data-testid="navbar-updated">{meta.updated_at ? `Last saved ${new Date(meta.updated_at).toLocaleString()} by ${meta.updated_by}` : "Using the default (all pages pinned)"}</span>
      </div>
    </div>
  );
}
